import http from "./http";
import url from "@/config/url";
import tg_business from "./tg_business";
import activity from "./activity";
import member from "./member";
import accounts from "./accounts";
import game from "./game";
import third_party from "./third_party";
import other from "./other";

const dashboard = {
  getColumns: () => http.post(url.dashboard.columns),
  search: (params) => http.post(url.dashboard.search, params),
  getDetailColumns: (params) => http.post(url.dashboard.detailColumns, params),
  getDetail: (params) => http.post(url.dashboard.detail, params),
};

const app = {
  getService: () => http.post(url.app.service),
  getInfo: () => http.post(url.app.info),
  getLang: (params) => http.post(url.app.lang, params)
};

export default {
  app,
  dashboard,
  tg_business,
  activity,
  member,
  accounts,
  game,
  third_party,
  ...other,
};
